import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getByMonth, getTals } from "../../store/reducers/dataReducer";
import {
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
} from "../common/Style";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { parseIsoDate } from "../common/others/Functions";

const TalsPayments = () => {
  const dispatch = useDispatch();
  const [tals, setTals] = useState(null);
  const [year, setYear] = useState(parseIsoDate(new Date()).split("/")[2]);
  const [month, setMonth] = useState(parseIsoDate(new Date()).split("/")[1]);
  const [talName, setTalName] = useState(null);

  const handleChange = (selectedOption) => setTalName(selectedOption.value);
  useEffect(() => {
    dispatch(getTals()).then((res) => {
      if (!res.payload?.error) {
        let arr = [];
        for (let i = 0; i < res.payload.data.length; i++)
          arr.push({ value: res.payload.data[i], label: res.payload.data[i] });
        setTals(arr);
      } else toast.error(res.payload?.error);
    });
  }, []);

  const handleGetByMonth = () => {
    dispatch(getByMonth({ year, month, talName })).then((res) => {
      if (!res.payload?.error) {
        let sum = 0;
        for (let i = 0; i < res.payload.length; i++)
          sum += parseFloat(res.payload[i].sum);
        toast.info(sum.toFixed(2));
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        {tals && (
          <div style={{ marginBottom: "100px", paddingBottom: "100px" }}>
            <Label>בחירת עובד/ת</Label>
            <Select options={tals} onChange={handleChange} />
          </div>
        )}
        <FlexRowBetween>
          <div style={{ width: "40%" }}>
            <Label style={{ marginTop: "20px" }}>שנה</Label>
            <Input
              type="number"
              defaultValue={year}
              onChange={(e) => setYear(e.target.value)}
              min={2023}
            />
          </div>
          <div style={{ width: "40%" }}>
            <Label style={{ marginTop: "20px" }}>חודש</Label>
            <Input
              type="number"
              defaultValue={month}
              onChange={(e) => setMonth(e.target.value)}
              min={0}
              max={12}
            />
          </div>
        </FlexRowBetween>
        <GenericDiv
          onClick={handleGetByMonth}
          style={{ margin: "10px auto", marginTop: "30px" }}
        >
          שליחה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default TalsPayments;
